import type { StrictOmit } from '@frontend/duck-tape';
import { applyClass, mergeAndConcatClasses } from '@frontend/web-utils';
import { forwardRef } from 'react';
import type { DivProps } from 'react-html-props';
import type { FlexDirection } from './Stacks/helpers';
import { flexDirectionTwMapping } from './Stacks/helpers';

export type ClickableProps = StrictOmit<DivProps, 'onClick'> & {
  canFocus?: boolean;
  disabled?: boolean;
  enableHoverEffect?: boolean;
  flexDirection?: FlexDirection;
  onClick?: DivProps['onClick'];
};

export const Clickable = forwardRef<HTMLDivElement, ClickableProps>(
  (
    {
      canFocus = true,
      className,
      disabled = false,
      enableHoverEffect = false,
      flexDirection = 'column',
      onClick,
      ...props
    },
    ref,
  ) => (
    <div
      aria-disabled={disabled}
      className={mergeAndConcatClasses(
        applyClass(enableHoverEffect && !!onClick && !disabled, 'hover-background-effect hover:bg-neutral-100'),
        applyClass(disabled, 'cursor-not-allowed'),
        flexDirection ? flexDirectionTwMapping[flexDirection] : undefined,
        'flex',
        className,
      )}
      onClick={disabled ? undefined : onClick}
      ref={ref}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick && canFocus ? 0 : undefined}
      {...props}
    />
  ),
);
